export {default} from 'views/SymbolGroups/SymbolGroups'


// WEBPACK FOOTER //
// ./src/views/Administration/SymbolGroups.jsx